module.exports = __webpack_public_path__ + "static/media/attach.b65fd496.svg";